"use client";

import { z } from "zod";

export const packageCategoryFormSchema = z.object({
  name: z.string().min(1, { message: "Required" }),
  description: z.string().optional(),
});

export const packageSubCategoryFormSchema = z.object({
  name: z.string().min(1, { message: "Required" }),
  color: z.string().min(1, { message: "Required" }),
});
